import { useTranslation } from "react-i18next";
import Input from "../Input";

import { IInputProps } from "../inputTypes";

const TextInput: React.FC<IInputProps> = (props) => {
  const { t } = useTranslation();
  return (
    <Input
      {...props}
      render={(inputProps) => (
        <>
          <input
            style={{ textAlign: "right" }}
            placeholder={t("common.fillIn")}
            {...inputProps}
            autoComplete="off"
          />
        </>
      )}
    />
  );
};

export default TextInput;
